/**
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
var angular = require('angular');
angular
    .module('satv.search')

    //the search paginate loader
    .factory('SearchLoader', ['LoaderFactory', '$resource', 'config', function (LoaderFactory, $resource, config) {
        "use strict";
        return function (params) {
            var resource = $resource(config.apiUri + '/search', {}, {
                //here because query doesn't return an array
                query: {
                    method: "GET"
                }
            });

            var loader = new LoaderFactory(resource, params, {"totalResultCount": "totalFound"});

            //override parse response to deal with different datastructure
            loader.parseResponse = function (resp) {
                if (loader.page === 0) {
                    loader.data = resp.data;
                    loader.filters = resp.filters;
                    loader.totalFound = resp.totalFound;
                    loader.meta = resp.meta;
                } else {
                    loader.data = loader.data.concat(resp.data);
                }
            };

            loader.getPageData = function (resp) {
                return resp.data;
            };

            return loader;
        };
    }])

    .config(['$httpProvider', 'config', function ($httpProvider, config) {
        $httpProvider.interceptors.push(function () {
            "use strict";
            return {
                'request': function (c) {
                    if (c.url.indexOf(config.apiUri + '/search') !== -1 &&
                        c.params
                    ) {
                        //convert 'property' to 'property[]' if it is an array
                        //so that it generates a request like &a[]=1&a[]=2.
                        //this cannot be done using transformrequest as they
                        //are query params
                        angular.forEach(c.params, function (v, k) {
                            if (angular.isArray(v) && k.substr(-2) !== '[]') {
                                c.params[k + '[]'] = v;
                                delete c.params[k];
                            }
                        });
                    }

                    return c;
                }
            };
        });
    }])

    .factory('SearchConfig', ['$state', function ($state) {
        "use strict";
        var searchConfig;
        var searchConfigMeta = {};

        return {

            /**
             * @param {Object} c
             * @return {Object} this
             */
            init: function (c) {
                searchConfig = c;
                return this;
            },

            /**
             * Applies the configuration and changes the state
             *
             *  @return {Object} this
             */
            apply: function () {
                $state.go('search', searchConfig);
                return this;
            },

            /**
             * @return {Object}
             */
            getModel: function () {
                return searchConfig;
            },

            /**
             * @param  {Object} c
             * @param  {Boolean} defer
             * @return {Object} this
             */
            set: function (c, defer) {
                angular.copy(c, searchConfig);

                if (!defer) {
                    this.apply();
                }

                return this;
            },

            /**
             * @param  {String} key
             * @param  {Boolean} defer
             * @return {Object}
             */
            unset: function (key, defer) {
                delete searchConfig[key];

                if (!defer) {
                    this.apply();
                }

                return this;
            },

            /**
             * Whether a value is set
             *
             * @param  {string} key
             * @param  {string} value
             * @return {Boolean}
             */
            isset: function (key, value) {
                var p = this.getProperty(key);

                if (angular.isArray(p)) {
                    return value ?
                        p.indexOf(value) !== -1 :
                        p.length > 0;
                } else {
                    return value ?
                        p === value :
                        p !== undefined;
                }
            },

            /**
             * @param  {string} key
             * @return mixed
             */
            getProperty: function (key) {
                return searchConfig[key];
            },

            /**
             * Toggles an multivalue key/value.
             *
             * Note that this is only to be used with array values.
             *
             * @param  {String} key
             * @param  {Boolean} value
             * @param  {Boolean} defer
             */
            toggle: function (key, value, defer) {
                var p, i;

                p = this.getArrayProperty(key);

                if (typeof value === 'string' && !isNaN(parseInt(value))) {
                    i = p.indexOf(parseInt(value));
                } else {
                    i = p.indexOf(value);
                }

                if (i !== -1) {
                    p.splice(i, 1);
                } else {
                    p.push(value);
                }

                searchConfig[key] = p;

                if (!defer) {
                    this.apply();
                }
            },

            /**
             * Returns the property if it is an array, or returns an empty array.
             * This will allow the setting and defining of which properties are
             * array values more easily.
             *
             * @param  {String} key
             * @return {Array}
             */
            getArrayProperty: function (key) {
                var p = this.getProperty(key);

                if (angular.isArray(p)) {
                    return p;
                } else if (p !== undefined) {
                    return [p];
                }

                return [];
            },

            /**
             * @return {Object}
             */
            getModelMeta: function () {
                return searchConfigMeta;
            },

            toggleMeta: function (key, value, meta) {
                var p, i;

                //p = this.getArrayProperty(key);
                // p = searchConfigMeta[key][value];


                // if (i !== -1) {
                //     p.splice(i, 1);
                // } else {
                //     p.push(value);
                // }
                if (typeof searchConfigMeta[key] === 'undefined') {
                    searchConfigMeta[key] = {};
                }
                if (typeof searchConfigMeta[key][value] === 'undefined') {
                    searchConfigMeta[key][value] = null;
                }
                searchConfigMeta[key][value] = meta;

            },
        };
    }])

    .factory('Search', ['$state', 'SearchLoader', 'SearchConfig', function ($state, SearchLoader, SearchConfig) {
        "use strict";

        var loader, searchConfig;

        return {

            /**
             * Inits the search
             */
            init: function (searchLoader) {
                loader = searchLoader;
                searchConfig = SearchConfig.init(searchLoader.getConfig());
                return loader;
            },

            /**
             * Registers a callback
             * @param {Function} callback
             */
            onSearch: function (callback) {
                loader.callbacks.push(callback);
            },

            /**
             * @return {SearchConfig}
             */
            getConfig: function () {
                return searchConfig;
            },

            /**
             * @return {SearchLoader}
             */
            getLoader: function () {
                return loader;
            }
        };
    }])
;




// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/Resources/js/angular/services/Search.js